// src/ProductFloat.js
import React, { useState, useEffect } from 'react';
import Ideapng from '../resorcesfiles/images/idea.png'
import { toBeRequired } from '@testing-library/jest-dom/matchers';
import * as IoIcons from 'react-icons/io'
import P80 from '../resorcesfiles/ideak/p80.jpg'
import U300 from '../resorcesfiles/ideak/u300.jpg'
import Cp30 from '../resorcesfiles/ideak/cp30.jpg'
import C72 from '../resorcesfiles/ideak/c72.jpg'
import Antenna from '../resorcesfiles/ideak/antenna.jpg'

const ProductFloat = () => {
  const [hovered, setHovered] = useState(20);
  const [showHardware, setshowHardware] = useState(true)
  const [showTags, setshowTags] = useState(false)
  const [showmobilecomp, setshowmobilecomp] = useState(false)
  const [showrTablets, setshowrTablets] = useState(false)
  const [showfixedreader, setshowfixedreader] = useState(false)
  const [showprinters, setshowprinters] = useState(false)
  const [showhandheld, setshowhandheld] = useState(false)
  const [showantennas, setshowantennas] = useState(false)

  useEffect(() =>{
    //setshowhandheld(true)
  })


  const handleMouseEnter = (index) => {
    setHovered(index);
    if(index === 1 || index === 20){
      setshowrTablets(false)
      setshowfixedreader(false)
      setshowantennas(false)
      setshowprinters(false)
      setshowhandheld(true)
    }else if(index === 2){
      setshowhandheld(false)
      setshowfixedreader(false)
      setshowantennas(false)
      setshowprinters(false)
      setshowrTablets(true)

    }else if (index === 4){
      setshowhandheld(false)
      setshowrTablets(false)
      setshowantennas(false)
      setshowprinters(false)
      setshowfixedreader(true)
    }else if (index === 5){
      setshowfixedreader(false)
      setshowhandheld(false)
      setshowrTablets(false)
      setshowprinters(false)
      setshowantennas(true)
    }else if (index === 6){
      setshowantennas(false)
      setshowfixedreader(false)
      setshowhandheld(false)
      setshowrTablets(false)
      setshowprinters(true)
    }

  };

  const handleMouseLeave = () => {
    setHovered(null);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '95%', margin: '10px auto', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.7)', borderRadius: '10px', backgroundColor: '#fff' }}>
      
      <div style={{ flex: 1, padding: '20px', fontSize: '14px',backgroundColor:'#eee' }}>
        <h2 style={{ marginBottom: '20px' }}>Category</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 20 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => {handleMouseEnter(20); setshowHardware(true);setshowTags(false)}} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Hardware <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>   

          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 21 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => {handleMouseEnter(21); setshowHardware(false);setshowTags(true)}} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Tag <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
        </ul>
      </div>

      {showHardware &&   
      <>
            <div style={{ flex: 1, padding: '20px', fontSize: '14px',backgroundColor:'#eee'}}>
        <h2 style={{ marginBottom: '20px' }}>Browse</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {/* <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 0 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => handleMouseEnter(0)} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Mobile Computers <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>   */}
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 1 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => handleMouseEnter(1)} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Handheld RFID Readers <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 2 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => handleMouseEnter(2)} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Rugged Tablets <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          {/* <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 3 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => handleMouseEnter(3)} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Bluetooth RFID Readers <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>   */}
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 4 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => handleMouseEnter(4)} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Fixed RFID Readers <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 5 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => handleMouseEnter(5)} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Antennas <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd', backgroundColor: hovered === 6 ? 'gray' : 'transparent',display:'flex',flexDirection:'row' }} onMouseEnter={() => handleMouseEnter(6)} onMouseLeave={handleMouseLeave}>&nbsp;&nbsp;&nbsp;Printers <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
        </ul>
      </div>
      </>
      }

                  {showhandheld && 
                            <div style={{ flex: 2, padding: '20px', fontSize: '14px'}}>
                            <h2 style={{ marginBottom: '20px' }}>Handheld RFID Readers</h2>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 10 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(10)} onMouseLeave={handleMouseLeave}>C72 UHF RFID Reader (Android 11/13) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
                            </ul>
                          </div>

                  }

                     {showhandheld && 
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',flexDirection:'column' }}>
                              <div style={{flex:1,marginTop:'20px'}}>
                              <h4 style={{ marginBottom: '10px',color:'black' }}>C72 UHF RFID Reader (Android 11/13)</h4>
                              <label style={{ marginBottom: '0px',color:'gray' }}>Industry-leading RFID Performance</label>
                              </div>

                              <div style={{flex:1}}>
                              <img src={C72} alt="RFID Reader" style={{ maxWidth: '100%', borderRadius: '10px',objectFit:'contain' }} />
                              </div>

                            </div>

                  }



                       {showrTablets && 
                            <div style={{ flex: 2, padding: '20px', fontSize: '14px'}}>
                            <h2 style={{ marginBottom: '20px' }}>Rugged Tablets</h2>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 10 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(10)} onMouseLeave={handleMouseLeave}>Industrial Tablet (Android 13)<div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
                            </ul>
                          </div>
                  }

                     {showrTablets && 
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',flexDirection:'column' }}>
                              <div style={{flex:1,marginTop:'20px'}}>
                              <h4 style={{ marginBottom: '10px',color:'black' }}>Industrial Tablet (Android 13)</h4>
                              <label style={{ marginBottom: '0px',color:'gray' }}>More Power, More Features and More Versatility</label>
                              </div>

                              <div style={{flex:1}}>
                              <img src={P80} alt="RFID Reader" style={{ maxWidth: '100%', borderRadius: '10px',objectFit:'contain' }} />
                              </div>

                            </div>
                  }


                       {showfixedreader && 
                            <div style={{ flex: 2, padding: '20px', fontSize: '14px'}}>
                            <h2 style={{ marginBottom: '20px' }}>Fixed RFID Readers</h2>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 10 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(10)} onMouseLeave={handleMouseLeave}>Fixed RFID Reader (Android 11)<div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
                            </ul>
                          </div>
                  }

                     {showfixedreader && 
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',flexDirection:'column' }}>
                              <div style={{flex:1,marginTop:'20px'}}>
                              <h4 style={{ marginBottom: '10px',color:'black' }}>Fixed RFID Reader (Android 11)</h4>
                              <label style={{ marginBottom: '0px',color:'gray' }}>Android 11 OS, Multiple Interfaces, More Powerful UHF RFID Performance</label>
                              </div>

                              <div style={{flex:1}}>
                              <img src={U300} alt="RFID Reader" style={{ maxWidth: '100%', borderRadius: '10px',objectFit:'contain' }} />
                              </div>

                            </div>
                  }


    {showantennas && 
                            <div style={{ flex: 2, padding: '20px', fontSize: '14px'}}>
                            <h2 style={{ marginBottom: '20px' }}>Panel Antenna</h2>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 10 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(10)} onMouseLeave={handleMouseLeave}>Ant-RC09 9dBi Panel Antenna<div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
                            </ul>
                          </div>
                  }

                     {showantennas && 
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',flexDirection:'column' }}>
                              <div style={{flex:1,marginTop:'20px'}}>
                              <h4 style={{ marginBottom: '10px',color:'black' }}>Ant-RC09 9dBi Panel Antenna</h4>
                              <label style={{ marginBottom: '0px',color:'gray' }}>Environmental Adaptability, Easy Installation</label>
                              </div>

                              <div style={{flex:1}}>
                              <img src={Antenna} alt="RFID Reader" style={{ maxWidth: '100%', borderRadius: '10px',objectFit:'contain' }} />
                              </div>

                            </div>
                  }



                      {showprinters && 
                            <div style={{ flex: 2, padding: '20px', fontSize: '14px'}}>
                            <h2 style={{ marginBottom: '20px' }}>RFID Printer</h2>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 10 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(10)} onMouseLeave={handleMouseLeave}>CP30 RFID Printer<div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
                            </ul>
                          </div>
                  }

                     {showprinters && 
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',flexDirection:'column' }}>
                              <div style={{flex:1,marginTop:'20px'}}>
                              <h4 style={{ marginBottom: '10px',color:'black' }}>CP30 RFID Printer</h4>
                              <label style={{ marginBottom: '0px',color:'gray' }}>Powerful RFID and Barcode Printing, Speedy and Highly Secured</label>
                              </div>

                              <div style={{flex:1}}>
                              <img src={Cp30} alt="RFID Reader" style={{ maxWidth: '100%', borderRadius: '10px',objectFit:'contain' }} />
                              </div>

                            </div>
                  }


{/* <div>

<div style={{ flex: 2, padding: '20px', fontSize: '14px'}}>
        <h2 style={{ marginBottom: '20px' }}>Handheld RFID Readers</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 10 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(10)} onMouseLeave={handleMouseLeave}>C60 - UHF RFID Reader (Android 11/13) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 11 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(11)} onMouseLeave={handleMouseLeave}>MC50 - UHF RFID Reader (Android 12) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 12 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(12)} onMouseLeave={handleMouseLeave}>C66 - Built-in RFID Reader (Android 11/13) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 13 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(13)} onMouseLeave={handleMouseLeave}>C71 - Built-in RFID Reader (Android 11) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 14 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(14)} onMouseLeave={handleMouseLeave}>C72 - UHF RFID Reader (Android 11/13) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 15 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(15)} onMouseLeave={handleMouseLeave}>C5 - UHF RFID Reader (Android 11/13) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 16 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(16)} onMouseLeave={handleMouseLeave}>C61 - UHF RFID Reader (Android 11/13) <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 17 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(17)} onMouseLeave={handleMouseLeave}>SR100 - UHF RFID Scanner <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0', borderBottom: '1px solid #ddd',display:'flex',flexDirection:'row', backgroundColor: hovered === 18 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(18)} onMouseLeave={handleMouseLeave}>R6 - UHF RFID Sled Reader <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
          <li style={{ padding: '10px 0',display:'flex',flexDirection:'row', backgroundColor: hovered === 19 ? '#007BFF' : '#fff' }} onMouseEnter={() => handleMouseEnter(19)} onMouseLeave={handleMouseLeave}>R2 - Bluetooth RFID Reader <div style={{flex:1}}></div> <IoIcons.IoIosArrowForward style={{color:'white'}}/></li>  
        </ul>
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <img src={Ideapng} alt="RFID Reader" style={{ maxWidth: '100%', borderRadius: '10px',objectFit:'contain' }} />
      </div>



</div>
 */}

      {/* </>
      } */}



      
    </div>
  );
};

export default ProductFloat;
